import * as React from "react";
import { cn } from "../lib/cn";
import { initials } from "../lib/format";

export type AvatarProps = {
  src?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeClasses = {
  sm: "size-8 text-xs",
  md: "size-11 text-sm",
  lg: "size-16 text-lg",
} as const;

/**
 * Avatar avec repli sur les initiales. Jamais d'icone « utilisateur »
 * generique : les initiales portent une identite, pas la silhouette grise.
 */
export function Avatar({ src, firstName, lastName, size = "md", className }: AvatarProps) {
  const label = initials(firstName, lastName);
  const name = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <span
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center overflow-hidden",
        "rounded-full bg-blush-100 font-medium text-blush-700",
        sizeClasses[size],
        className,
      )}
    >
      {src ? (
        <img src={src} alt={name} className="size-full object-cover" loading="lazy" />
      ) : (
        <span aria-hidden>{label}</span>
      )}
      {!src && <span className="sr-only">{name}</span>}
    </span>
  );
}
